import { useRecoilValue } from 'recoil';
import Table from 'components/common/Table/Table';
import { timezoneState } from 'components/common/Managers/PreferencesManager.state';
import { DataCardTabsProps } from '../../types';
import { createEndpointGeneralFieldsConfiguration, EndpointGeneralFieldConfiguration } from './GeneralFields';
import {
  EndpointTabs,
  generalNetworkTableHeaders,
  getDefaultEndpointCardTableOptions,
} from './DVEndpointDetailsRenderer.consts';
import './DVEndpointDetailsGeneral.scss';

export const DVEndpointDetailsRendererGeneral = ({ initialData }: DataCardTabsProps): JSX.Element => {
  const generalListItems = initialData?.s1Endpoint;
  const generalNetworkInterfaceTableItems = initialData?.s1Endpoint?.networkInterfaces || [];

  const timezone = useRecoilValue(timezoneState);
  const generalContentDataConfiguration = createEndpointGeneralFieldsConfiguration(timezone);

  const transformData = () =>
    generalContentDataConfiguration.map((item: EndpointGeneralFieldConfiguration) => {
      const generalFieldsValue = item.value(generalListItems);
      return (
        <div className="General__Item" key={item.key}>
          <div className="General__Key">{item.title}</div>
          <span className="General__Value">{generalFieldsValue || item.defaultValue}</span>
        </div>
      );
    });

  return (
    <div className="General__Container General">
      <div className="General__Content">{transformData()}</div>
      <span className="General__NetworkTitle">Network Adapters</span>
      <div className="General__NetworkTable">
        <Table
          headers={generalNetworkTableHeaders}
          data={generalNetworkInterfaceTableItems}
          options={getDefaultEndpointCardTableOptions(EndpointTabs.general)}
        />
      </div>
    </div>
  );
};

export default DVEndpointDetailsRendererGeneral;
